import Uploader from "../components/uploads/Uploader/Uploader";

//if an instance number is provided then remove it from the array and return true otherwise false
export const removeUploader = (instanceNumber, uploaderArray) => {
    if (instanceNumber != null) {
        const indexToRemove = uploaderArray.findIndex((uploader) => {
          return uploader.props.instanceNumber === instanceNumber;
        });
        if (indexToRemove !== -1) {
          uploaderArray.splice(indexToRemove, 1);
        }

        return true;
    }

    return false;
}

//add a new uploader to the array, if removeLast is true then remove the most recent uploader
export const addUploader = (uploaderArray, removeLast, updateFunc) => {
    const key = crypto.randomUUID();
    const newInstanceNumber = crypto.randomUUID();

    if (removeLast) {
        uploaderArray.pop();
    }
    
    uploaderArray.push(<Uploader key={key} uploaderCount={uploaderArray.length+1} instanceNumber={newInstanceNumber} handleCallback={updateFunc} />);

    return newInstanceNumber;
}